(function () {
  'use strict';

  var header = document.querySelector('[data-mizumi-header]');
  if (!header || header.hasAttribute('data-mizumi-header-init')) return;
  header.setAttribute('data-mizumi-header-init', 'true');

  var burger = header.querySelector('[data-mizumi-burger]');
  var menu = document.querySelector('[data-mizumi-menu]');
  var closeBtn = menu ? menu.querySelector('[data-mizumi-close]') : null;
  var backdrop = menu ? menu.querySelector('[data-mizumi-backdrop]') : null;
  var cartEls = document.querySelectorAll('[data-cart-count]');
  var cartLink = header.querySelector('.mizumi-header__cart');

  var lastFocused = null;
  var scrollLockY = 0;

  function setScrolled() {
    if (window.scrollY > 8) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  function lockScroll() {
    scrollLockY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollLockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollLockY);
  }

  function openMenu() {
    if (!menu) return;
    lastFocused = document.activeElement;
    menu.classList.add('open');
    menu.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    lockScroll();
    setTimeout(function () {
      if (closeBtn) closeBtn.focus();
    }, 50);
  }

  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('open');
    menu.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    unlockScroll();
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function trapFocus(e) {
    if (!menu || !menu.classList.contains('open') || e.key !== 'Tab') return;
    var focusable = menu.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function updateCartCount(count) {
    var n = Number(count) || 0;
    cartEls.forEach(function (el) {
      el.textContent = n;
      el.setAttribute('data-cart-count', n);
    });
    if (cartLink && n > 0) {
      cartLink.classList.remove('bump');
      void cartLink.offsetWidth;
      cartLink.classList.add('bump');
    }
  }

  function fetchCart() {
    if (!window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          updateCartCount(cart.item_count);
        }
      })
      .catch(function () { /* silent */ });
  }

  window.addEventListener('scroll', setScrolled, { passive: true });
  setScrolled();

  if (burger) {
    burger.addEventListener('click', function () {
      if (menu && menu.classList.contains('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);

  if (menu) {
    menu.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', function () {
        setTimeout(closeMenu, 80);
      });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && menu.classList.contains('open')) {
      closeMenu();
    } else if (e.key === 'Tab') {
      trapFocus(e);
    }
  });

  document.addEventListener('mizumi:cart-updated', function (e) {
    if (e && e.detail && typeof e.detail.item_count === 'number') {
      updateCartCount(e.detail.item_count);
    } else {
      fetchCart();
    }
  });

  fetchCart();
})();
